import { useState } from 'react';

import type { Goal } from '@feathr/blackbox';
import { useStore } from '@feathr/extender/state';
import type { ListResponse } from '@feathr/rachis';

export type TGoalTab = 'active' | 'archived' | 'all';

export interface IUseGoalManagerPageReturn {
  activeCount: number;
  archivedCount: number;
  goals: ListResponse<Goal>;
  filteredGoals: Goal[];
  tab: TGoalTab;
  search: string;
  setTab: (tab: TGoalTab) => void;
  setSearch: (search: string) => void;
}

export function useGoalManagerPage(): IUseGoalManagerPageReturn {
  const { Goals } = useStore();
  const [tab, setTab] = useState<TGoalTab>('active');
  const [search, setSearch] = useState('');

  const goals = Goals.list();
  const activeCount = Goals.count({ filters: { is_archived__ne: true } });
  const archivedCount = Goals.count({ filters: { is_archived: true } });

  const filteredGoals = goals.models.filter((goal) => {
    if (tab === 'active' && goal.get('is_archived')) {
      return false;
    }
    if (tab === 'archived' && !goal.get('is_archived')) {
      return false;
    }
    if (search && !goal.get('name').toLowerCase().includes(search.toLowerCase())) {
      return false;
    }
    return true;
  });

  return { activeCount, archivedCount, goals, filteredGoals, tab, search, setTab, setSearch };
}
